import React from "react"

import { communityItemRequest } from "../../actions/community-actions"

import CommunityFilterWidgetContainer from "./community-filter/CommunityFilterWidgetContainer"
import CommunityListWidgetContainer from "./community-list/CommunityListWidgetContainer"
import Community from "./community-item/Community"
import pageComponent from "../common/page-component-hoc"

const CommunitiesComponent = ({ isFilterActive }) => (
    <div id="community" className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="community-list-panel"
        >
            {isFilterActive ? (
                <CommunityFilterWidgetContainer />
            ) : (
                <CommunityListWidgetContainer />
            )}
        </div>
        <Community />
    </div>
)

export default pageComponent("communities", communityItemRequest)(
    CommunitiesComponent
)
